module.exports = {"name":"lghtml5","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2017-10-25","repo":"https://bitbucket.org/npaw/lghtml5-adapter-js","libVersion":"^6.1.0","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getPlayrate","getFramesPerSecond","getDroppedFrames","getDuration","getBitrate","getThroughput","getRendition","getTitle","getTitle2","getIsLive","getResource","getPosition"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 26
// module chunks = 0